import { NewsDetail } from '@news/routes/NewsDetail';
import { NewsOverview } from '@news/routes/NewsOverview';
import { Route, Routes } from 'react-router-dom';

export const NewsRoutes = () => {
    return (
        <Routes>
            <Route index element={<NewsOverview />} />
            <Route path=":id" element={<NewsDetail />} />
        </Routes>
    );
};
